/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `
<div class="swym-wishlist-grid">
   {{#products}} 
   <div class="swym-wishlist-item swym-is-anchor">
    <a href="{{du}}" aria-label="{{dt}}">
        <div class="swym-wishlist-image-wrapper">
            <img alt="" class="swym-wishlist-image" src="{{iu}}">
        </div>
        <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
      	<svg width="16" height="16" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd" d="M12 2L15.09 8.58255L22 9.64458L17 14.7655L18.18 22L12 18.5825L5.82 22L7 14.7655L2 9.64458L8.91 8.58255L12 2Z" stroke="black" style="stroke:black;stroke-opacity:1" stroke-linecap="round" stroke-linejoin="round"></path>
		</svg>
        </button>
    </a>

    <div>
      <div class="swym-title swym-title-1">
        {{dt}}
       </div>

       <div class="swym-product-price swym-text swym-text-1">
          <div class="swym-product-final-price swym-value">
            ${"$"}{{pr}}
          </div>
        </div>

        <div class="swym-variant-title swym-text swym-title-2 swym-variant-select">
			<span class="variant-size-title">Size</span>
			<select data-wishlist-product-handle="{{handle}}" class="variant-control drawer-atc-trigger"></select>
        </div>

        <button data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="account-drawer__cta-button atc-btn" disabled>
          Add To Cart
        </button>
    </div>
   </div>
   {{/products}}
</div>`;

async function getProductVariants(product) {
	async function getProductData(handle) {
		const results = await fetch('https://bassike.myshopify.com/api/2024-10/graphql.json', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'X-Shopify-Storefront-Access-Token': 'dcb3cc2ec54bf04e7586c21aaa5903e8',
			},
			body: JSON.stringify({
				query: `{
					product(handle: "${handle}") {
						title
						handle
						variants(first: 100) {
							edges {
								node {
									id
									availableForSale
									title
								}
							}
						}
					}
				}`
			})
		});
		const res = await results.json();
		return res?.data?.product?.variants?.edges || [];
	}

	if (product.handle) {
		return getProductData(product.handle).then(res => res);
	}
	return [];
}

async function renderSelects(product) {
  const selects = document.querySelectorAll(`[data-wishlist-product-handle="${product.handle}"]`);
  if (selects?.length && product) {
    const variants = await getProductVariants(product);
    const savedVariantId = product.epi?.toString();

    const options = `
      <option value="">Select A Size</option>
      ${variants.map((v) => {
        const variantId = v?.node?.id?.split('ProductVariant/')?.[1];
        if (v?.node?.availableForSale) {
          const selected = variantId === savedVariantId ? 'selected="selected"' : '';
          return `<option value="${variantId}" ${selected}>${v?.node?.title}</option>`;
        }
        return '';
      }).join('')}
    `;

    for (let i = 0; i < selects.length; i += 1) {
      const select = selects[i];
      select.innerHTML = options;

      const parent = select.closest('.swym-wishlist-item');
      const button = parent?.querySelector('button.atc-btn');

      if (savedVariantId && button) {
        button.dataset.variantId = savedVariantId;
        button.disabled = false;
      }

      select.addEventListener('change', (e) => {
        const selectedValue = e.target.value;
        if (button) {
          button.dataset.variantId = selectedValue;
          button.disabled = !selectedValue;
        }
      });

      if (button && !button.__swymAtcBound) {
        button.__swymAtcBound = true;
        button.addEventListener('click', () => {
          const toast = document.querySelector('.toast-message');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: button.dataset.variantId, quantity: 1 }]
            })
          })
            .then(response => response.json())
            .then(() => {
              if (toast) {
                toast.innerHTML = `<p>Added to cart</p>`;
                toast.classList.add('active');
                setTimeout(() => toast.classList.remove('active'), 3000);
              }
              window.location.reload();
            })
            .catch(() => {
              if (toast) {
                toast.innerHTML = `<p>Unable to add to cart</p>`;
                toast.classList.add('active');
                setTimeout(() => toast.classList.remove('active'), 3000);
              }
            });
        });
      }
    }
  }
}

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
	}, function(err) {});
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	});
}

function swymRenderWishlist(swat) {
	swat.fetch(function(products) {
		var wishlistContentsContainer = document.querySelectorAll(".wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p);
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			p.handle = p.du.split('/products/')[1];
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer.length){
			wishlistContentsContainer.forEach((container) => {
				container.innerHTML = productCardsMarkup;
				attachClickListeners();
     		});

			setTimeout(() => {
				formattedWishlistedProducts?.forEach(p => renderSelects(p));
			}, 1000);
		}
	});

	swat.fetchLists({
		callbackFn: (lists) => {
			const list = lists[0];
			const lid = lists[0].lid;
			window.SwymListId = lid;

			const wishlistWrapper = document.querySelector('.wishlist-card-wrapper');
			if (lists?.[0]?.listcontents?.length) {
				const emptyWrapper = document.querySelector('.wishlist-empty');
				if (emptyWrapper) {
					emptyWrapper.style.display = 'none';
				}
				if (wishlistWrapper) {
					const content = wishlistWrapper.querySelector('.account-drawer__item');
					if (content) {
						content.style.display = 'flex';
					}
					wishlistWrapper.classList.remove('wishlist-card-wrapper');
				}
			}

			const addToCartButtons = document.querySelectorAll("product-card .custom-add-to-wishlist-button");
			addToCartButtons.forEach((button) => {
				if(button) {
					button.addEventListener("click", (e) => {
						const target = e.currentTarget;
						const product = {
							empi: target.getAttribute("data-product-id"),
							epi: target.getAttribute("data-variant-id"),
							du: target.getAttribute("data-product-url")
						};
						const onSuccess = () => { swymRenderWishlist(swat); };
						const onError = () => {};
						swat.addToList(lid, product, onSuccess, onError);
					});
				}
			});

			updateButtonState(list);
		},
		errorFn: () => {}
	});
}

const updateButtonState = (list) => {
  const swymWishlistButtons = document.querySelectorAll('.custom-add-to-wishlist-button');
  if (!swymWishlistButtons) return;

  swymWishlistButtons.forEach((button) => {
    const productId = button.getAttribute('data-product-id');
    const variantId = button.getAttribute('data-variant-id');
    let isWishlisted = false;

    if (list && list.listcontents?.length) {
      list.listcontents.forEach(item => {
        if (item.empi == productId && item.epi == variantId) {
          isWishlisted = true;
        }
      });
    }

    updateButtonWishlistState(button, isWishlisted);
  });
};

const updateButtonWishlistState = (element, isWishlisted) => {
	if (isWishlisted) {
		element.classList.add('swym-added');
	} else {
		element.classList.remove('swym-added');
	}
};

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}

function initializeSwym() {
    if (!window._swat) {
        setTimeout(initializeSwym, 1000);
        return;
    }
	const pdpEmptyIcon = document.querySelector(".pdp-empty-icon");
	if (pdpEmptyIcon) {
		pdpEmptyIcon.style.opacity = "0";
		setTimeout(() => {
			pdpEmptyIcon.style.opacity = "1";
		}, 800);
	}
    const swat = window._swat;
    swymRenderWishlist(swat);

    const toggleButtons = document.querySelectorAll('.toggle-wishlist');
    if (toggleButtons.length) {
        for (let i = 0; i < toggleButtons.length; i += 1) {
            const btn = toggleButtons[i];
            btn.addEventListener('click', (e) => {
                if (e.target.className.includes('swym-added')) {
                    onRemoveBtnClick(e);
                } else {
                    const product = {
                        epi: e.target.dataset.variantId,
                        empi: e.target.dataset.productId,
                        du: e.target.dataset.productUrl
                    };
                    swat.addToList(window.SwymListId, product, () => {
                        e.target.classList.add('swym-added');
                        if (e.target.className.includes('cart-line')) {
                            e.target.innerText = 'Added to wishlist';
                        }
						if (e.target.dataset.removeUrl) {
							fetch(e.target.dataset.removeUrl)
							.then(() => { window.location.reload(); })
							.catch(() => { window.location.reload(); });
						}
                        swymRenderWishlist(swat);
                    }, () => {});
                }
            });
        }
    }
}

window.SwymCallbacks.push(initializeSwym);

document.addEventListener('DOMContentLoaded', () => {
    initializeSwym();
});
